import React from 'react';
import { Container, Typography } from '@material-ui/core';

import './WorkingOn.css';

const WorkingOn = () => (
  <Container className="WorkingOn">
    <Typography variant="h4" color="secondary" className="efecto-espejo">
      Actualmente estamos trabajando en esta página.
    </Typography>
    <img title="WorkingOn: Página en desarrollo." src="./assets/desarrollo-de-software.png" className="img-center" />
  </Container>
)

export default WorkingOn;